import { Box, HStack, Tooltip, useColorModeValue } from '@chakra-ui/react'

import FirestoreUser from '../../../../types/FirestoreUser'

interface Props {
  profile: FirestoreUser['profile'] | undefined
  additionalDetails: FirestoreUser['additionalDetails']
  medicalDetails: FirestoreUser['medicalDetails']
}

export function ProfileBadges({
  profile,
  additionalDetails,
  medicalDetails,
}: Props) {
  const verifiedColor = useColorModeValue('green.500', 'green.300')
  const p2Color = useColorModeValue('blue.500', 'blue.300')
  const p3Color = useColorModeValue('teal.500', 'teal.300')

  const hasAnyBadge =
    profile?.agreedToProfileCheckbox || additionalDetails || medicalDetails

  if (!hasAnyBadge) return null

  const showP2 =
    additionalDetails?.isComplete ||
    (additionalDetails && additionalDetails.isComplete === undefined)

  return (
    <HStack mt={1} spacing={2}>
      {profile?.agreedToProfileCheckbox && (
        <Tooltip
          label='Profile step 1 completed'
          hasArrow
          placement='top'
          openDelay={300}
        >
          <Box
            boxSize='5'
            bg={verifiedColor}
            color='white'
            borderRadius='full'
            display='inline-flex'
            alignItems='center'
            justifyContent='center'
            fontSize='xs'
            fontWeight='bold'
            aria-label='Profile agreed'
          >
            P1
          </Box>
        </Tooltip>
      )}

      {showP2 && (
        <Tooltip
          label='Profile step 2 completed'
          hasArrow
          placement='top'
          openDelay={300}
        >
          <Box
            boxSize='5'
            bg={p2Color}
            color='white'
            borderRadius='full'
            display='inline-flex'
            alignItems='center'
            justifyContent='center'
            fontSize='xs'
            fontWeight='bold'
            aria-label='Profile step 2'
          >
            P2
          </Box>
        </Tooltip>
      )}

      {medicalDetails && (
        <Tooltip
          label='Profile step 3 completed'
          hasArrow
          placement='top'
          openDelay={300}
        >
          <Box
            boxSize='5'
            bg={p3Color}
            color='white'
            borderRadius='full'
            display='inline-flex'
            alignItems='center'
            justifyContent='center'
            fontSize='xs'
            fontWeight='bold'
            aria-label='Profile step 3'
          >
            P3
          </Box>
        </Tooltip>
      )}
    </HStack>
  )
}
